
import React from 'react';
import { Helmet } from 'react-helmet';
import { Container } from 'react-bootstrap';
import c from './img/asterisk.png';
import './Permitforuseexceeds.css';

export const Permitforuseexceeds = () => {
  const pageUrl = 'https://rishuy-asakim.co.il/permit-for-use';

  const pageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'רישוי עסקים במבנים לא מוסדרים – היתר לשימוש חורג',
    description:
      'מידע על רישוי עסקים במבנים ללא היתר בנייה, בדיקת התאמה לתב״ע, שימוש חורג, תיקון 101 לחוק התכנון והבנייה והגשת בקשות במערכת רישוי זמין.',
    url: pageUrl,
    inLanguage: 'he-IL',
    isPartOf: {
      '@type': 'WebSite',
      name: 'רישוי עסקים ישראל',
      url: 'https://rishuy-asakim.co.il/'
    },
    publisher: {
      '@type': 'Organization',
      name: 'רישוי עסקים ישראל',
      url: 'https://rishuy-asakim.co.il/'
    },
    about: [
      {
        '@type': 'Thing',
        name: 'רישוי עסקים'
      },
      {
        '@type': 'Thing',
        name: 'היתר לשימוש חורג'
      },
      {
        '@type': 'Thing',
        name: 'חוק התכנון והבנייה'
      },
      {
        '@type': 'Thing',
        name: 'תיקון 101 לחוק התכנון והבנייה'
      },
      {
        '@type': 'Thing',
        name: 'רישוי זמין'
      }
    ]
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'ראשי',
        item: 'https://rishuy-asakim.co.il/'
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'היתר לשימוש חורג',
        item: pageUrl
      }
    ]
  };

  return (
    <Container>

      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(pageSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>

      <div className="permit-page">

        <div className="permit-card">

          <p className="permit-intro">
            בהתאם להנחיות ולדינים החלים על רישוי עסקים במבנים שאינם מוסדרים,
            המחלקה לתכנון ולרישוי הנדסי בוחנת את התאמת הבקשה לדיני התכנון והבנייה,
            בין היתר בנושאים הבאים:
          </p>

          <div className="permit-list-container">

            <div className="permit-list-item">
              <img src={c} alt="בדיקת חוקיות המבנה" className="permit-list-icon" />
              <p className="permit-list-text">
                חוקיות המבנה והיתר הבנייה.
              </p>
            </div>

            <div className="permit-list-item">
              <img src={c} alt="בדיקת מבנה ללא היתר בנייה" className="permit-list-icon" />
              <p className="permit-list-text">
                במקרים שבהם אין היתר בנייה, נבדקת האפשרות להסדרת רישוי העסק בהתאם להוראות הדין ולתנאים החלים על הנכס.
              </p>
            </div>

            <div className="permit-list-item">
              <img src={c} alt="בדיקת התאמת השימוש לייעוד המבנה" className="permit-list-icon" />
              <p className="permit-list-text">
                התאמת השימוש בנכס לייעוד המבנה על פי היתר הבנייה ותוכנית בניין עיר (תב"ע).
              </p>
            </div>

          </div>

          <p className="permit-secondary-text">
            בדיקה זו רלוונטית, בין היתר, כאשר השימוש המבוקש אינו תואם את היתר הבנייה או את התוכנית החלה על הנכס.
          </p>

          <div className="permit-article-section">

            <h2 className="permit-article-title">
              רישוי עסקים במבנים לא מוסדרים
            </h2>

            <p className="permit-article-intro">
              דיני תכנון ובנייה והנחיות היועץ המשפטי לממשלה
            </p>

            <p className="permit-article-text">
              פתיחת עסק או חידוש רישיון במבנה שאינו מוסדר מבחינה תכנונית
              עשויים להציב אתגר משפטי ומנהלי. במסגרת בחינת הבקשה,
              נבדקת התאמת הנכס והשימוש המבוקש לדיני התכנון והבנייה
              ולהנחיות הרלוונטיות החלות על רישוי עסקים.
            </p>

            <p className="permit-article-text">
              מטרת הבדיקה היא למנוע מצב שבו רישיון העסק יכשיר בעקיפין
              עבירות בנייה או שימושים שאינם מותרים, תוך בחינת האפשרויות
              החוקיות להסדרת הפעילות במקרים המתאימים.
            </p>

            <div className="permit-article-block">

              <h3 className="permit-section-title">
                שלושת צירי הבדיקה של מחלקת ההנדסה
              </h3>

              <div className="permit-article-cards">

                <div className="permit-article-card">

                  <div className="permit-article-card-number">
                    01
                  </div>

                  <div>
                    <h4 className="permit-article-card-title">
                      חוקיות המבנה והיתר הבנייה
                    </h4>

                    <p className="permit-article-card-text">
                      המחלקה בוחנת האם המבנה הפיזי שבו מתוכנן לפעול העסק
                      הוקם בהתאם להיתרי הבנייה ולמסמכים התכנוניים הקיימים,
                      והאם ניתן לאתר עבורו היתר בנייה במערכות הרשות.
                    </p>
                  </div>

                </div>

                <div className="permit-article-card">

                  <div className="permit-article-card-number">
                    02
                  </div>

                  <div>
                    <h4 className="permit-article-card-title">
                      מבנים ללא היתר בנייה
                    </h4>

                    <p className="permit-article-card-text">
                      כאשר לא נמצא היתר בנייה מוסדר, נבחנות נסיבות המקרה
                      והוראות הדין הרלוונטיות. במקרים מסוימים עשויות
                      להתקיים אפשרויות מוגדרות להמשך הליך רישוי העסק,
                      בכפוף לעמידה בתנאים הקבועים בחוק.
                    </p>
                  </div>

                </div>

                <div className="permit-article-card">

                  <div className="permit-article-card-number">
                    03
                  </div>

                  <div>

                    <h4 className="permit-article-card-title">
                      התאמת השימוש לייעוד המבנה
                    </h4>

                    <p className="permit-article-card-text">
                      נבדקת ההתאמה בין סוג הפעילות של העסק לבין
                      הייעוד והשימושים המותרים בנכס, כפי שנקבעו
                      בהיתר הבנייה ובתוכנית בניין עיר (תב"ע).
                    </p>

                    <div className="permit-example-box">
                      <strong>לדוגמה:</strong>{' '}
                      הפעלת חנות מסחר במבנה המיועד למגורים או לתעשייה,
                      כאשר השימוש המבוקש אינו תואם את התכנון החל.
                    </div>

                  </div>

                </div>

              </div>

            </div>

            <div className="permit-warning-box">

              <div className="permit-warning-icon">
                ⚠
              </div>

              <div>

                <h3 className="permit-warning-title">
                  חובת בעל העסק: הסדרת שימוש חורג ותיקון 101
                </h3>

                <p className="permit-warning-text">
                  כאשר נמצאת אי-התאמה בין פעילות העסק המבוקשת לבין
                  היתר הבנייה או התוכנית החלה על הנכס, ייתכן שיהיה
                  צורך בהליך תכנוני להסדרת השימוש, בהתאם לנסיבות
                  המקרה ולהוראות הדין.
                </p>

                <p className="permit-warning-text">
                  במקרים שבהם נדרש היתר לשימוש חורג, יש להגיש בקשה
                  בהתאם להליך הקבוע בחוק התכנון והבנייה ובתקנותיו.
                  אופן הגשת הבקשה והמסמכים הנדרשים תלויים בסוג
                  הבקשה ובהוראות הרשות התכנונית המוסמכת.
                </p>

              </div>

            </div>

            <div className="permit-article-block">

              <h3 className="permit-section-title">
                כמה זמן לוקח לקבל היתר לשימוש חורג?
              </h3>

              <p className="permit-article-text">
                משך הטיפול בבקשה לשימוש חורג משתנה בהתאם למורכבות
                הבקשה, לדרישות התכנון, להליכי הפרסום, להתנגדויות
                אפשריות ולעומס העבודה בוועדה המקומית.
                לכן, מומלץ להביא בחשבון כי מדובר בהליך שעשוי להימשך
                מספר חודשים ואף יותר.
              </p>

              <div className="permit-steps">

                <div className="permit-step">
                  <span className="permit-step-number">1</span>

                  <div>
                    <strong className="permit-step-title">
                      הכנת תוכניות
                    </strong>

                    <p className="permit-step-text">
                      הכנת תוכניות ומסמכים תכנוניים על ידי בעל מקצוע מוסמך,
                      בהתאם לדרישות ההליך.
                    </p>
                  </div>
                </div>

                <div className="permit-step">
                  <span className="permit-step-number">2</span>

                  <div>
                    <strong className="permit-step-title">
                      פרסום הבקשה
                    </strong>

                    <p className="permit-step-text">
                      פרסום הבקשה ומתן אפשרות להגשת התנגדויות,
                      ככל שנדרש ובהתאם להוראות החוק.
                    </p>
                  </div>
                </div>

                <div className="permit-step">
                  <span className="permit-step-number">3</span>

                  <div>
                    <strong className="permit-step-title">
                      דיון בוועדה
                    </strong>

                    <p className="permit-step-text">
                      דיון בבקשה בוועדה המקומית לתכנון ובנייה
                      וקבלת החלטה בהתאם לשיקולים התכנוניים והמשפטיים.
                    </p>
                  </div>
                </div>

              </div>

            </div>

            <div className="permit-danger-section">

              <h3 className="permit-danger-title">
                סיכונים וסנקציות: מה קורה אם פועלים ללא היתר תואם?
              </h3>

              <p className="permit-article-text">
                הפעלת עסק בניגוד להיתר הבנייה או לתוכנית החלה על הנכס,
                ללא הסדרה נדרשת, עלולה להוביל להליכי אכיפה
 ולסנקציות בהתאם לחוק התכנון והבנייה ולנסיבות המקרה.
              </p>

              <div className="permit-danger-list">

                <div className="permit-danger-item">
                  <span>●</span>

                  <div>
                    <strong>קנסות כספיים</strong>

                    <p>
                      קנסות מנהליים או קנסות במסגרת הליכים משפטיים,
                      בהתאם להוראות הדין.
                    </p>
                  </div>
                </div>

                <div className="permit-danger-item">
                  <span>●</span>

                  <div>
                    <strong>צווים משפטיים ומינהליים</strong>

                    <p>
                      הליכי אכיפה העלולים לכלול צווים להפסקת שימוש
                      או פעילות והליכים משפטיים.
                    </p>
                  </div>
                </div>

                <div className="permit-danger-item">
                  <span>●</span>

                  <div>
                    <strong>פגיעה בהליך רישוי העסק</strong>

                    <p>
                      אי-הסדרת השימוש עלולה לעכב או למנוע את קבלת
                      רישיון העסק או היתר זמני, בהתאם לנסיבות ולדין.
                    </p>
                  </div>
                </div>

              </div>

            </div>

            <div className="permit-system-box">

              <div className="permit-system-header">

                <div className="permit-system-icon">
                  💻
                </div>

                <div>
                  <h3 className="permit-system-title">
                    מדריך קצר: הגשת בקשה במערכת "רישוי זמין"
                  </h3>

                  <p className="permit-system-subtitle">
                    שלבי התהליך להסדרת הבקשה באופן מקוון
                  </p>
                </div>

              </div>

              <div className="permit-system-steps">

                <div className="permit-system-step">

                  <span className="permit-system-number">
                    01
                  </span>

                  <div>
                    <strong>
                      הזדהות ממשלתית
                    </strong>

                    <p>
                      כניסה למערכת הרלוונטית באמצעות מערכת ההזדהות
                      הלאומית, בהתאם לאפשרויות ההתחברות הקיימות.
                    </p>
                  </div>

                </div>

                <div className="permit-system-step">

                  <span className="permit-system-number">
                    02
                  </span>

                  <div>
                    <strong>
                      מינוי עורך בקשה
                    </strong>

                    <p>
                      במקרים שבהם נדרש עורך בקשה, יש להיעזר
                      בבעל מקצוע מוסמך בהתאם לסוג הבקשה ולהוראות
                      הדין, אשר יכין ויגיש את המסמכים הנדרשים.
                    </p>
                  </div>

                </div>

                <div className="permit-system-step">

                  <span className="permit-system-number">
                    03
                  </span>

                  <div>
                    <strong>
                      קליטת ובחינת התיק
                    </strong>

                    <p>
                      הגשת המסמכים, המדידות והתוכניות הנדרשות
                      במערכת המתאימה, והעברתם לבחינת הגורם
                      התכנוני המוסמך.
                    </p>
                  </div>

                </div>

              </div>

            </div>

            <div className="permit-bottom-summary">

              <span className="permit-summary-icon">
                ✓
              </span>

              <p>
                <strong>חשוב:</strong>{' '}
                מומלץ לבדוק את מצב הנכס ואת ההתאמה התכנונית שלו
                כבר בתחילת תהליך פתיחת העסק, כדי לזהות מראש
                בעיות שעלולות לעכב את קבלת הרישיון.
              </p>

            </div>

          </div>

          <div className="permit-final-warning">

            <span className="permit-final-warning-title">
              חשוב לדעת:
            </span>

            <p className="permit-final-warning-text">
              תיקון 101 לחוק התכנון והבנייה עוסק, בין היתר,
              בשינויים בהליכי התכנון והרישוי. אופן הגשת בקשה
              לשימוש חורג נקבע בהתאם לסוג הבקשה ולהוראות
              הדין והמערכות המקוונות הרלוונטיות.
            </p>

          </div>

        </div>

      </div>

    </Container>
  );
};
